import React, { useEffect, useState } from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Button } from 'primereact/button';
import { Text } from '../../../components/Text';
import { API_GET_ALL_METADATA } from '../../../api/metadata.service';
import { useUtility } from '../../../context/UtilityContext';
import { capitalizeFLetter, formatMobNumber } from '../../../utils/commonUtils';

const WcaMetadataTab = () => {
  const [metadata, setMetadata] = useState([]);
  const [metadataLoading, setMetadataLoading] = useState(false);
  const [metadataError, setMetadataError] = useState(null);
  const { selectedMetadataId, setSelectedMetadataId } = useUtility();

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        setMetadataLoading(true);
        setMetadataError(null);

        const data = await API_GET_ALL_METADATA(0, 50);
        setMetadata(data.rows || []);
      } catch (err) {
        setMetadataError(err.message || 'Failed to fetch metadata.');
      } finally {
        setMetadataLoading(false);
      }
    };

    fetchMetadata();
  }, []);

  if (metadataLoading) {
    return (
      <div className="p-4">
        <Skeleton height="2rem" className="mb-2" />
        <Skeleton height="1rem" className="mb-2" />
        <Skeleton height="1rem" className="mb-2" />
        <Skeleton height="1rem" />
      </div>
    );
  }

  if (metadataError) {
    return (
      <div className="p-4 text-red-500">
        <p>Error: {metadataError}</p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <Text type="heading" cust="bold mb-3">
        WhatsApp Business Accounts
      </Text>

      {!metadata || metadata.length === 0 ? (
        <p>No active WhatsApp Business Accounts found.</p>
      ) : (
        <div className="grid">
          {metadata.map((meta) => {
            const isSelected = selectedMetadataId === String(meta.id);

            return (
              <div key={meta.id} className="col-12 md:col-6 lg:col-4 p-3">
                <div
                  className={`p-3 border-2 border-round surface-card transition-all duration-200 ${
                    isSelected ? 'border-green-500 shadow-3' : 'border-gray-200'
                  }`}
                >
                  <div className="flex justify-content-between align-items-center mb-2">
                    <Text type="sub-heading" cust="bold">
                      Name
                    </Text>
                  </div>

                  <Text cust="mt-1">{capitalizeFLetter(meta?.name) || '—'}</Text>

                  <Text type="sub-heading" cust="bold mt-3">
                    Phone Number
                  </Text>
                  <Text cust="mt-1">{formatMobNumber(meta?.phoneNumber) || '—'}</Text>

                  <div className="flex justify-content-end mt-3">
                    <Button
                      label={isSelected ? 'Default Selected' : 'Set as Default'}
                      icon={isSelected ? 'pi pi-check' : 'pi pi-star'}
                      className={`p-button-sm ${
                        isSelected ? 'p-button-success' : 'p-button-outlined'
                      }`}
                      onClick={() => setSelectedMetadataId(String(meta.id))}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WcaMetadataTab;
